import type { IReimbursementCategory, IReimbursementRequest, TReimbursementStatus } from "@/types"
import { api } from "./api"
import { generateAPIResource, generateSetupActivity } from "./utils"

export const reimbursementSetupAPI = generateSetupActivity("/reimbursement")

export const reimbursementCategoryAPI = generateAPIResource<IReimbursementCategory>("/reimbursement/categories")

export const reimbursementRequestAPI = {
  ...generateAPIResource<IReimbursementRequest>("/reimbursement/requests", {
    create: true,
    update: false,
    remove: false,
  }),
  review: (id: string, payload: { status: TReimbursementStatus; rejection_reason?: string }) =>
    api.post<IReimbursementRequest>(`/reimbursement/requests/${id}/review`, payload).then((res) => res.data),

  upload: (id: string, file: File) => {
    const data = new FormData()
    data.append("file", file)
    return api.post<IReimbursementRequest>(`/reimbursement/requests/${id}/upload`, data).then((res) => res.data)
  },
}
